import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FixedAspectRatioDiv} from '@rcm/fixed-aspect-ratio-div-react';

export default class SuggestedProductView extends Component {
    render() {
        const product = this.props.product;
        return (<a className="suggested-product"
                   href={product.url}
                   style={
                       {
                           'display': 'inline-block',
                           'width': 100 / this.props.productCount + '%',
                           'textAlign': 'center',
                           'verticalAlign': 'top',
                           'padding': '0 5px 0 5px',
                       }
                   }>
                <FixedAspectRatioDiv aspectRatio={'1:1'}>
                    <img className="suggestedProductImage" src={product.imageSrc}
                         style={{height: '100%'}}/>
                </FixedAspectRatioDiv>
                <div className="suggested-product-name">{product.name}</div>
                <div className="suggested-product-price">{product.formattedRetailPrice}</div>
            </a>
        );
    }

    static propTypes = {
        product: PropTypes.object.isRequired,
        productCount: PropTypes.number.isRequired,
    };
}
